import randomColor from 'randomcolor';
import { getLabel } from '../assets/consts';

export const calculateData = () => {
  const calculateProtocolByAttendants = (response) => {
    const { totalProtocolsPerUser } = response;

    let arrayLabels = [];
    let arrayData = [];
    let arrayColors = [];
    let totalCount = 0;

    if (totalProtocolsPerUser) {
      arrayLabels = totalProtocolsPerUser.map((protocol) => {
        return protocol.protocol_current_responsible.name;
      });
      arrayData = totalProtocolsPerUser.map((protocol) => {
        return parseInt(protocol.total);
      });

      totalCount = arrayData.reduce(function (sum, i) {
        return sum + i;
      }, 0);

      for (let index = 0; index < arrayData.length; index++) {
        arrayColors.push(randomColor({ luminosity: 'random', hue: 'random' }));
      }

      const returnData = {
        arrayLabels,
        arrayData,
        arrayColors,
        totalCount
      };

      return returnData;
    }
    return null;
  };

  const calculateTotalProtocolsPerMonth = (response) => {
    let days = [];
    let quantity = [];

    const filterMonth = response.filter((month) => month.month > 0);

    filterMonth.forEach((el) => {
      days.push(getLabel(el.day, el.month, el.year));
      quantity.push(el.total);
    });

    const returnData = {
      data: {
        labels: [...days],
        datasets: [
          {
            label: 'Protocolos',
            data: [...quantity],
            backgroundColor: '#00a17c',
            maxBarThickness: 10
          }
        ]
      }
    };

    return returnData;
  };

  const calculateTotalProtocolsPerStatus = (response) => {
    let labels = [];
    let datasets = [
      {
        label: 'Total de protocolos: ',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1
      }
    ];
    let protocolDataForSubtitles = [];
    let totalProtocolPerMonth = 0;

    if (response !== null) {
      response.forEach((res) => {
        const convertToTotalNumberOfProtocolsPerMonth = Number(res.total);
        totalProtocolPerMonth =
          convertToTotalNumberOfProtocolsPerMonth + totalProtocolPerMonth;
      });

      response.forEach((res) => {
        labels.push(res?.status?.name || 'Protocolo criado sem status/fase');
        let backgroundColor = randomColor({
          luminosity: 'random',
          hue: 'random',
          format: 'rgb'
        });
        datasets[0].data.push({
          y: res.total,
          percentage:
            Number(res.total * 100) / Number(totalProtocolPerMonth).toFixed(2)
        });
        datasets[0].backgroundColor.push(backgroundColor);
        datasets[0].borderColor.push(backgroundColor);
        protocolDataForSubtitles.push({
          name: res?.status?.name || 'Protocolo criado sem status/fase',
          backgroundColor
        });
      });
    }

    const data = {
      labels: [...labels],
      datasets: [...datasets],
      protocolDataForSubtitles
    };

    return data;
  };

  const calculateTotalProtocolsPerReason = (response) => {
    let labels = [];
    let datasets = [
      {
        label: 'Total de protocolos: ',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1
      }
    ];
    let protocolDataForSubtitles = [];
    let totalProtocolPerMonth = 0;

    if (response !== null) {
      response.forEach((res) => {
        const convertToTotalNumberOfProtocolsPerMonth = Number(res.total);
        totalProtocolPerMonth =
          convertToTotalNumberOfProtocolsPerMonth + totalProtocolPerMonth;
      });
      response.forEach((res) => {
        labels.push(res?.reason?.name || 'Protocolo criado sem motivo');
        let backgroundColor = randomColor({
          luminosity: 'random',
          hue: 'random',
          format: 'rgb'
        });
        datasets[0].data.push({
          y: res.total,
          percentage:
            Number(res.total * 100) / Number(totalProtocolPerMonth).toFixed(2)
        });
        datasets[0].backgroundColor.push(backgroundColor);
        datasets[0].borderColor.push(backgroundColor);
        protocolDataForSubtitles.push({
          name: res?.reason?.name || 'Protocolo criado sem motivo',
          backgroundColor
        });
      });
    }
    const data = {
      labels: [...labels],
      datasets: [...datasets],
      protocolDataForSubtitles
    };

    return data;
  };

  const calculateTotalProtocolsPerSubReason = (response) => {
    let labels = [];
    let datasets = [
      {
        label: 'Total de protocolos: ',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1
      }
    ];
    let protocolDataForSubtitles = [];
    let totalProtocolPerMonth = 0;

    if (response !== null) {
      response.forEach((res) => {
        const convertToTotalNumberOfProtocolsPerMonth = Number(res.total);
        totalProtocolPerMonth =
          convertToTotalNumberOfProtocolsPerMonth + totalProtocolPerMonth;
      });
      response.forEach((res) => {
        labels.push(res?.subreason?.name || 'Protocolo criado sem submotivo');
        let backgroundColor = randomColor({
          luminosity: 'random',
          hue: 'random',
          format: 'rgb'
        });
        datasets[0].data.push({
          y: res.total,
          percentage:
            Number(res.total * 100) / Number(totalProtocolPerMonth).toFixed(2)
        });
        datasets[0].backgroundColor.push(backgroundColor);
        datasets[0].borderColor.push(backgroundColor);
        protocolDataForSubtitles.push({
          name: res?.subreason?.name || 'Protocolo criado sem submotivo',
          backgroundColor
        });
      });
    }
    const data = {
      labels: [...labels],
      datasets: [...datasets],
      protocolDataForSubtitles
    };

    return data;
  };

  const calculateTotalProtocolsPerStatusForPieChart = (response) => {
    let arrayLabels = [];
    let arrayData = [];
    let arrayColors = [];

    if (response !== null) {
      response.forEach((res) => {
        const statusName =
          res?.status?.name || 'Protocolo criado sem status/fase';
        const total = parseInt(res.total, 10);

        arrayLabels.push(statusName);
        arrayData.push(total);
        arrayColors.push(randomColor({ luminosity: 'random', hue: 'random' }));
      });
    }

    return {
      arrayLabels,
      arrayData,
      arrayColors
    };
  };

  const calculateProtocolsSlaByConformity = (response) => {
    let arrayLabels = ['Conforme', 'Não conforme'];
    let arrayData = [];
    let arrayColors = [];

    if (response) {
      arrayData.push(response.conformingProtocols || 0);
      arrayData.push(response.nonConformingProtocols || 0);
      arrayColors.push(randomColor({ luminosity: 'random', hue: 'random' }));
      arrayColors.push(randomColor({ luminosity: 'random', hue: 'random' }));
    } else {
      arrayData = [0, 0];
      arrayColors = ['#cccccc', '#cccccc'];
    }

    return {
      arrayLabels,
      arrayData,
      arrayColors
    };
  };

  const calculateTotalProtocolsForBarChart = (response) => {
    let days = [];
    let quantity = [];

    const filterMonth = response.filter((month) => month.month > 0);

    filterMonth.forEach((el) => {
      days.push(getLabel(el.day, el.month, el.year));
      quantity.push(el.total);
    });

    const returnData = {
      data: {
        labels: [...days],
        datasets: [
          {
            label: 'Protocolos',
            data: [...quantity],
            backgroundColor: '#00a17c',
            maxBarThickness: 10
          }
        ]
      }
    };

    return returnData;
  };

  const calculateTotalProtocolsPerCriticalityForPieChart = (response) => {
    let arrayLabels = [];
    let arrayData = [];
    let arrayColors = [];

    if (Array.isArray(response)) {
      response.forEach((res) => {
        arrayLabels.push(res.label || 'Criticidade não especificada');
        arrayData.push(res.value);
        arrayColors.push(randomColor({ luminosity: 'random', hue: 'random' }));
      });
    }

    const returnData = {
      arrayLabels,
      arrayData,
      arrayColors
    };

    return returnData;
  };

  const calculateTotalProtocolsPerServiceTypeForPieChart = (response) => {
    let arrayLabels = [];
    let arrayData = [];
    let arrayColors = [];

    if (Array.isArray(response)) {
      response.forEach((res) => {
        arrayLabels.push(res.label || 'Serviço não especificado');
        arrayData.push(res.value);
        arrayColors.push(randomColor({ luminosity: 'random', hue: 'random' }));
      });
    }

    const returnData = {
      arrayLabels,
      arrayData,
      arrayColors
    };

    return returnData;
  };

  const calculateTotalProtocolsPerServiceChannel = (data) => {
    let labels = [];
    let dataValues = [];
    let backgroundColor = [];

    if (Array.isArray(data)) {
      data.forEach((item) => {
        labels.push(item.service_channel || 'Não especificado');
        dataValues.push(parseInt(item.total, 10));
        backgroundColor.push(
          randomColor({ luminosity: 'random', hue: 'random' })
        );
      });
    }

    return {
      labels,
      data: dataValues,
      backgroundColor
    };
  };

  const formatClosedByTimeInterval = (data = {}) => {
    return {
      labels: [
        'Ultrapassaram o tempo',
        'Entre 0 e 5 horas',
        'Entre 5 e 24 horas',
        'De 1 a 7 dias',
        'De 7 a 30 dias',
        'Mais de 30 dias'
      ],
      data: [
        data.exceededTime || 0,
        data.between0And5Hours || 0,
        data.between5And24Hours || 0,
        data.between1And7Days || 0,
        data.between7And30Days || 0,
        data.moreThan30Days || 0
      ],
      colors: [
        'rgba(75,192,192,0.4)',
        'rgba(75,192,192,0.4)',
        'rgba(75,192,192,0.4)',
        'rgba(75,192,192,0.4)',
        'rgba(75,192,192,0.4)',
        'rgba(75,192,192,0.4)'
      ]
    };
  };

  const formatDataForBarChartByHour = (data) => {
    const hours = Array(24).fill(0);

    if (Array.isArray(data)) {
      data.forEach((item) => {
        const hour = item.hour;
        hours[hour] += parseInt(item.total, 10);
      });
    }

    const labels = hours.map((_, index) => `${index}:00`);
    const colors = labels.map(() =>
      randomColor({ luminosity: 'random', hue: 'random' })
    );

    return {
      labels,
      data: hours,
      colors
    };
  };

  const formatDataForBarChartByWeekday = (data) => {
    const weekdays = Array(7).fill(0);
    const weekdayNames = [
      'Domingo',
      'Segunda-feira',
      'Terça-feira',
      'Quarta-feira',
      'Quinta-feira',
      'Sexta-feira',
      'Sábado'
    ];

    if (Array.isArray(data)) {
      data.forEach((item) => {
        const weekday = item.weekday;
        weekdays[weekday] += parseInt(item.total, 10);
      });
    }

    const labels = weekdayNames;
    const colors = labels.map(() =>
      randomColor({ luminosity: 'random', hue: 'random' })
    );

    return {
      labels,
      data: weekdays,
      colors
    };
  };

  const formatDataForBarChartByUser = (data) => {
    const userNames = [];
    const userTotals = [];

    if (Array.isArray(data)) {
      data.forEach((item) => {
        userNames.push(item.current_responsible);
        userTotals.push(parseInt(item.total, 10));
      });
    }

    const colors = userNames.map(() =>
      randomColor({ luminosity: 'random', hue: 'random' })
    );

    return {
      labels: userNames,
      data: userTotals,
      colors
    };
  };

  return {
    calculateProtocolByAttendants,
    calculateTotalProtocolsPerMonth,
    calculateTotalProtocolsPerStatus,
    calculateTotalProtocolsPerReason,
    calculateTotalProtocolsPerSubReason,
    calculateTotalProtocolsPerStatusForPieChart,
    calculateProtocolsSlaByConformity,
    calculateTotalProtocolsForBarChart,
    calculateTotalProtocolsPerCriticalityForPieChart,
    calculateTotalProtocolsPerServiceTypeForPieChart,
    calculateTotalProtocolsPerServiceChannel,
    formatDataForBarChartByHour,
    formatClosedByTimeInterval,
    formatDataForBarChartByWeekday,
    formatDataForBarChartByUser
  };
};
